// extracted by css-extract-rspack-plugin
export default {"mobilePrompt":"_eb5f0fd8","showMobilePrompt":"_6e0a92fb","img":"_73e8fadf"};